import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '@app/store/reducer'

const careersStateSelector = (state: AppState) => state.careers

export const jobsListSelector = createSelector(
  careersStateSelector,
  careersStateSelector => careersStateSelector.careersData?.departments || []
)
